<template>
  <div>
    <BaseButton type="button" primary class="flex items-center" @click="createNewFunnel">
      <span>New</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 inline-flex ml-2 -mr-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    </BaseButton>
  </div>
</template>

<script>
import { accountFunnelsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    onCreated: {
      type: Function,
      default: () => {
        //
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async createFunnel(data) {
      try {
        await accountFunnelsClient.store(this.accountId, data);

        this.onCreated();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    createNewFunnel() {
      this.$modal.show({
        component: () => import('Components/Funnel/FunnelModal.vue'),
        props: {
          action: this.createFunnel,
          defaultData: {
            source: 'facebook',
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
